import { Header } from "@Components/Header";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { StyledActivation } from "./Activation.styled";

const Activation: React.FC = () => {
    const navigate = useNavigate();
    const query = new URLSearchParams(window.location.search);
    const ui = query.get("ui");
    const ai = query.get("ai");
    const [success, setSuccess] = useState<boolean>(false);

    const verifyActivation = async () => {
        try {
            const response = await axios.post("/account/confirm", {
                user_id: ui,
                activation_token: ai,
            });
            if (response) setSuccess(true);
        } catch (error) {
            returnHome();
        }
    };

    const returnHome = () => {
        navigate("/", { state: { activation_failed: true } });
    };

    useEffect(() => {
        ui && ai ? verifyActivation() : returnHome();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Header showNav={false} showJoinButton={true} />
            <StyledActivation>
                {!success && (
                    <CircularProgress color="secondary" size={"10rem"} />
                )}
                {success && (
                    <>
                        <h1 className="m-1">
                            Account verified{" "}
                            <span role="img" aria-label="celebrate">
                                🥳
                            </span>
                        </h1>
                        <span>You can now login to your account.</span>
                    </>
                )}
            </StyledActivation>
        </>
    );
};

export default Activation;
